import React from 'react'
import PromoBanner from './Blogbanner';
import promoImage from '../../assets/promobanner.png'; // adjust to your path
import './Blogbanner.css'
function Promo() {
  return (
  
    <PromoBanner
      backgroundImage={promoImage}
      badgeText="up to"
      discount="56%"
      offText="off"
      heading="Fresh Fruit"
      subheading="Summer Sales"
      buttonText="Shop Now"
    />  )
}

export default Promo;